<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <v-card>
      <v-toolbar flat dense color="transparent">
        <v-toolbar-title>{{place_name}}</v-toolbar-title>
        <v-spacer />
        <v-icon @click="$emit('dialog', false)">close</v-icon>
      </v-toolbar>
      <v-card-text class="text-xs-center pt-0">
        <!-- <v-scale-transition>
                <v-card v-show="edit_img" class="text-xs-left">
                    <v-card-text>
                    Edit image : <v-btn small depressed>Choose File</v-btn> <br>
                    File name : 123.png
                    <v-text-field label="กรุณากรอกเลข 6 หลัก" placeholder="xxx-xxx" mask="###-###" hide-details></v-text-field>
                    </v-card-text>
                </v-card> 
        </v-scale-transition>-->
        <v-img :src="view_img_position" alt width="400px" v-if="view_img_position != null" />
        <!-- <v-btn depressed color="primary" class="black--text" @click="edit_img = !edit_img"><v-icon>edit</v-icon> edit</v-btn> -->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "view_img_position", "place_name"],
  data() {
    return {};
  }
};
</script>

<style>
</style>
